(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9939],{

/***/ 83542:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pricing",
      function () {
        return __webpack_require__(10602);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 96088:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/basedash.fb1a5610.png","height":132,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAElBMVEUUFBRMaXEUFBQUFBQVFRUVFRUg6cLcAAAABnRSTlM/AGcwhiPWrtZ8AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAG0lEQVQImWNgYWFmYGZgYGBgYmIFUQwMjFAAAAIiACDE01x9AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 12066:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/impira.e073a466.png","height":123,"width":537,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAFVBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAASAQCkAAAAB3RSTlM/RjFebSNWGXPk5gAAAAlwSFlzAAALEwAACxMBAJqcGAAAABpJREFUCJljYGRiZGBkZmBkYGFlYGJhZmADAAD5ACJt8n73AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});

/***/ }),

/***/ 29358:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/knock.f920fb7c.png","height":111,"width":350,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAG1BMVEUEBAQNBQQHBAQEBARMaXEEBAQEBAQEBAQAAwQrY+akAAAACXRSTlOPagqoAJqFgEHVxxVnAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIElEQVQImWNgYQJBDkYGRgY2djZGBlYGBnZWZmYGNmYABEoAUT4VhGgAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 75428:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/mage.a68f0773.png","height":142,"width":570,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAD1BMVEUAAAAAAAAAAAAAAAAAAABPDueNAAAABXRSTlNDUDeS4aNr4ukAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAWSURBVAiZY2BiYWZiYGBgZGAGMxgZAQEaABuwiNxCAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});

/***/ }),

/***/ 81783:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/portal.98c21457.png","height":77,"width":250,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAElBMVEUAAAAAAAAAAAAAAAAAAAAAAADgKxmiAAAABnRSTlNsWTFjgUEF1le7AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAGklEQVQImWNgYWZkYGJlYmZgYGBiZGBkZgEAAT0AIO1XJrYAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});

/***/ }),

/***/ 92905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ CompaniesReel; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/Home/Home.module.scss
var Home_module = __webpack_require__(19350);
var Home_module_default = /*#__PURE__*/__webpack_require__.n(Home_module);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
;// CONCATENATED MODULE: ./public/images/companies/airplane.png
/* harmony default export */ var airplane = ({"src":"/_next/static/media/airplane.ef0c6262.png","height":116,"width":475,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAGFBMVEUAAAAEBgkNEBgAAAAAAAAMAxcSCBsJCRXvGuWLAAAACHRSTlMjNG0aQA5Lg/S+FJEAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAaSURBVAiZY2BkZ2VmYGBgZmBiYmNgYWRhBAABhAAotSJibAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});
// EXTERNAL MODULE: ./public/images/companies/basedash.png
var basedash = __webpack_require__(96088);
// EXTERNAL MODULE: ./public/images/companies/knock.png
var knock = __webpack_require__(29358);
;// CONCATENATED MODULE: ./public/images/companies/pipe.png
/* harmony default export */ var pipe = ({"src":"/_next/static/media/pipe.b1c6ce16.png","height":115,"width":394,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAG1BMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACUUeIgAAAACXRSTlOAoI0vlG5lR8bcG/bfAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGklEQVQImWNgZGRmYmJiYGHgYGZnYmVkYwAAAYIAMNAScEcAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});
// EXTERNAL MODULE: ./public/images/companies/impira.png
var impira = __webpack_require__(12066);
// EXTERNAL MODULE: ./public/images/companies/portal.png
var portal = __webpack_require__(81783);
;// CONCATENATED MODULE: ./public/images/companies/hightouch.png
/* harmony default export */ var hightouch = ({"src":"/_next/static/media/hightouch.999a8962.png","height":169,"width":531,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAG1BMVEUEBQgFBQgFBQgFBQgFBQgFBQgFBQgFBQgFBQgc8PHuAAAACXRSTlMEKll3ZzgOGU+PJIYuAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIElEQVQImWNgYGBjYAARLMzMLCwcTCwMrEzsjKyMjOwAA00ASmiPEu4AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./public/images/companies/dripos.png
/* harmony default export */ var dripos = ({"src":"/_next/static/media/dripos.5d498b60.png","height":72,"width":304,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAFVBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAASAQCkAAAAB3RSTlNnUVyKMTN/stixzgAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAABdJREFUCJljYGZhZmQAQQYWBlY2RiYmAAEsACI8HrcnAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});
// EXTERNAL MODULE: ./public/images/companies/mage.png
var mage = __webpack_require__(75428);
;// CONCATENATED MODULE: ./public/images/companies/secoda.svg
/* harmony default export */ var secoda = ({"src":"/_next/static/media/secoda.c127824d.svg","height":23,"width":135});
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/common/Typography/Typography.tsx
var Typography = __webpack_require__(20026);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/Home/CompaniesReel/CompaniesReel.tsx

















const CompaniesReel = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Home_module_default()).anchorFeature,
        id: "customers",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Home_module_default()).anchorHead,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "mb-2",
                        children: "Our customers"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                        type: "copy2",
                        onDark: true,
                        children: [
                            "Highlight powers forward-thinking companies.",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/customers",
                                children: "Find out more about our customers →"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Home_module_default()).customerReel,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Home_module_default()).companies,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: pipe,
                            alt: "Pipe",
                            className: (Home_module_default()).scaleHeight,
                            style: {
                                transform: "scale(0.9)"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: portal/* default */.Z,
                            alt: "Portal",
                            className: (Home_module_default()).scaleHeight
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: dripos,
                            alt: "Dripos",
                            className: (Home_module_default()).scaleHeight
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: knock/* default */.Z,
                            alt: "Knock",
                            className: (Home_module_default()).scaleHeight
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: hightouch,
                            alt: "Hightouch",
                            className: (Home_module_default()).scaleHeight,
                            style: {
                                transform: "scale(1.1)"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: basedash/* default */.Z,
                            alt: "Basedash"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: impira/* default */.Z,
                            alt: "Impira",
                            className: (Home_module_default()).scaleHeight
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: mage/* default */.Z,
                            alt: "Mage",
                            className: (Home_module_default()).scaleHeight
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: airplane,
                            alt: "Airplane",
                            className: (Home_module_default()).scaleHeight
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()((Home_module_default()).tabletGraphic, (Home_module_default()).hideMobile)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: secoda,
                            alt: "Secoda",
                            className: (Home_module_default()).scaleHeight,
                            style: {
                                transform: "scale(0.8)"
                            }
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 62223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Section; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Section_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50246);
/* harmony import */ var _Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Section_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const Section = (param)=>{
    let { reverseMobile , className , children , noYBottomPadding , noYTopPadding , grid , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ...props,
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, (_Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default().section), {
            [(_Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default().sectionReverseMobile)]: reverseMobile,
            [(_Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default().noYTopPadding)]: noYTopPadding,
            [(_Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default().noYBottomPadding)]: noYBottomPadding,
            [(_Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default().gridSection)]: grid
        }),
        children: children
    });
};


/***/ }),

/***/ 10602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "RangedInput": function() { return /* binding */ RangedInput; },
  "default": function() { return /* binding */ pricing; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/esm/ChevronDownIcon.js
var ChevronDownIcon = __webpack_require__(57349);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/esm/InformationCircleIcon.js
var InformationCircleIcon = __webpack_require__(85693);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/common/Buttons/PrimaryButton.tsx
var PrimaryButton = __webpack_require__(29204);
// EXTERNAL MODULE: ./components/common/CallToAction/FooterCallToAction.tsx + 1 modules
var FooterCallToAction = __webpack_require__(24035);
// EXTERNAL MODULE: ./components/common/Footer/Footer.tsx + 1 modules
var Footer = __webpack_require__(5945);
// EXTERNAL MODULE: ./components/common/Navbar/Navbar.tsx + 4 modules
var Navbar = __webpack_require__(93890);
// EXTERNAL MODULE: ./components/common/Typography/Typography.tsx
var Typography = __webpack_require__(20026);
// EXTERNAL MODULE: ./components/Home/Home.module.scss
var Home_module = __webpack_require__(19350);
var Home_module_default = /*#__PURE__*/__webpack_require__.n(Home_module);
// EXTERNAL MODULE: ./components/Pricing/Pricing.module.scss
var Pricing_module = __webpack_require__(8962);
var Pricing_module_default = /*#__PURE__*/__webpack_require__.n(Pricing_module);
;// CONCATENATED MODULE: ./public/images/credit-card.svg
/* harmony default export */ var credit_card = ({"src":"/_next/static/media/credit-card.212878e6.svg","height":16,"width":16});
;// CONCATENATED MODULE: ./public/images/delete.svg
/* harmony default export */ var images_delete = ({"src":"/_next/static/media/delete.1278a3f5.svg","height":16,"width":16});
;// CONCATENATED MODULE: ./public/images/globe.svg
/* harmony default export */ var globe = ({"src":"/_next/static/media/globe.1dc90133.svg","height":16,"width":16});
;// CONCATENATED MODULE: ./public/images/pc-play-media.svg
/* harmony default export */ var pc_play_media = ({"src":"/_next/static/media/pc-play-media.0e69c013.svg","height":20,"width":20});
;// CONCATENATED MODULE: ./public/images/receipt-list.svg
/* harmony default export */ var receipt_list = ({"src":"/_next/static/media/receipt-list.5cb65368.svg","height":16,"width":16});
;// CONCATENATED MODULE: ./public/images/security.svg
/* harmony default export */ var security = ({"src":"/_next/static/media/security.2681f794.svg","height":16,"width":16});
;// CONCATENATED MODULE: ./public/images/stopwatch.svg
/* harmony default export */ var stopwatch = ({"src":"/_next/static/media/stopwatch.4a134a7c.svg","height":20,"width":20});
;// CONCATENATED MODULE: ./public/images/tag-loyalty.svg
/* harmony default export */ var tag_loyalty = ({"src":"/_next/static/media/tag-loyalty.2daf62a8.svg","height":16,"width":16});
;// CONCATENATED MODULE: ./public/images/wallet.svg
/* harmony default export */ var wallet = ({"src":"/_next/static/media/wallet.9df2c29b.svg","height":16,"width":16});
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/radio-group/radio-group.js + 4 modules
var radio_group = __webpack_require__(56938);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-slider/dist/index.module.js + 16 modules
var index_module = __webpack_require__(81558);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-collapsible/dist/index.js
var dist = __webpack_require__(97893);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./components/common/Section/Section.tsx
var Section = __webpack_require__(62223);
// EXTERNAL MODULE: ./components/Home/CompaniesReel/CompaniesReel.tsx + 5 modules
var CompaniesReel = __webpack_require__(92905);
;// CONCATENATED MODULE: ./pages/pricing/index.tsx


























const PricingPage = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col w-full px-10 mx-auto mt-24",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-center text-center gap-9",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                className: "max-w-3xl",
                                children: [
                                    "Get the ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-highlight-yellow",
                                        children: "visibility"
                                    }),
                                    " you need today."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                type: "copy1",
                                onDark: true,
                                children: "Fair and transparent pricing that scales with any organization."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PlanTable, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-center mt-32 text-center gap-9",
                        id: "overage",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                children: [
                                    "Pay ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-highlight-yellow",
                                        children: "as you go."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                                type: "copy1",
                                onDark: true,
                                className: "max-w-4xl",
                                children: [
                                    "Each of our plans comes with a pre-defined usage quota, and if you exceed that quota, we charge an additional fee. For custom plans, ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "mailto:sales@highlight.io",
                                        children: "reach out to us"
                                    }),
                                    "."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceCalculator, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-10 mt-32 mb-20",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompaniesReel/* CompaniesReel */.T, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((Home_module_default()).anchorFeature, "mt-20"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Home_module_default()).anchorHead,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "Frequently asked questions"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: Faqs.map((faq, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Question, {
                                    question: faq.question,
                                    answer: faq.answer,
                                    icon: faq.icon
                                }, index))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterCallToAction/* FooterCallToAction */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
        ]
    });
};
const Question = (param)=>{
    let { question , answer , icon  } = param;
    const [expanded, setExpanded] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Pricing_module_default()).faqRowClickable,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                onOpening: ()=>setExpanded(true),
                onClosing: ()=>setExpanded(false),
                transitionTime: 200,
                trigger: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Pricing_module_default()).faqRow,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Pricing_module_default()).faqLeftContent,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: icon,
                                    alt: "pc icon"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                    className: (Pricing_module_default()).question,
                                    type: "copy2",
                                    emphasis: true,
                                    children: question
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: classnames_default()((Pricing_module_default()).circleButton, {
                                [(Pricing_module_default()).expanded]: expanded
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDownIcon/* default */.Z, {
                                className: classnames_default()("w-5 h-5", expanded ? "text-dark-background" : "text-blue-cta")
                            })
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Pricing_module_default()).collapseInner,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        className: (Pricing_module_default()).questionDescription,
                        type: "copy3",
                        onDark: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: answer
                            }
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                className: (Pricing_module_default()).faqDivider
            })
        ]
    });
};
const docsUrl = "/docs";
const Faqs = [
    {
        question: "Do you offer a discount for non-profits?",
        answer: "We love supporting non-profits and offer a 75% discount for the lifetime of the account. To activate the discount, create a workplace on either the Standard or Pro plan. Then reach out to support and mention the discount.",
        icon: tag_loyalty
    },
    {
        question: "How long does it take to setup Highlight?",
        answer: 'It generally takes an engineer less than ten minutes to understand the concepts of Highlight and integrate the app into their workflow. For more information on setup, take a look at our <a href="'.concat(docsUrl, '">docs</a>.'),
        icon: stopwatch
    },
    {
        question: "Can I deploy Highlight on-premise?",
        answer: 'Yes! To get a glimpse at how our hobby deployment process looks, take a look <a href="'.concat(docsUrl, '/general/company/open-source/self-host-hobby">here</a>. To get a license key for a production deployment, contacts at <a href="mailto:sales@highlight.io">sales@highlight.io</a>.'),
        icon: globe
    },
    {
        question: "Is Highlight secure? Where's my data stored?",
        answer: 'Highlight uses end-to-end encryption to keep your data safe while it’s in transit, and we also offer an on-prem solution if you want to keep customer data on your own servers. For more information, see our <a href="/#privacy">security section</a> and <a href="'.concat(docsUrl, '" target="_blank">docs</a>. If we don\'t answer your question there, <a href="mailto:jay@highlight.io">let us know</a>.'),
        icon: security
    },
    {
        question: "Do I need a credit card to sign up?",
        answer: "Absolutely not! We never ask for your credit card on sign up. If you start on a paid plan then 30 days after signing up you will be politely prompted to enter in your payment information. At anytime you can switch back to a free plan as long as your workplace has less than 6 seats.",
        icon: credit_card
    },
    {
        question: "How will you charge me?",
        answer: 'We ask for a credit card. Your credit card information will never touch our servers as we use <a href="https://stripe.com/" target="_blank">Stripe</a> as our payments processor. For Enterprise customers we can do ACH and custom invoices if requested.',
        icon: wallet
    },
    {
        question: "How does billing work?",
        answer: "We charge by usage; or number of sessions collected per month. Our billing system uses prorated billing, meaning you only pay for what you use below each of our thresholds (see above). For example if you move to the Startup plan from the Basic plan in the middle of the month, then you will only be charged for the time you are on the paid plan.",
        icon: receipt_list
    },
    {
        question: "What counts as a session?",
        answer: "A session is contiguous instance of a user's presence on your app for less than 4 hours. That is, if a user is browsing your application for 3 minutes, then closes the tab, this counts as a single session.",
        icon: pc_play_media
    },
    {
        question: "Can I cancel at anytime?",
        answer: "Definitely! You can cancel or downgrade your subscription at anytime. You can also delete your workplace in the settings page at anytime.",
        icon: images_delete
    }
];
const billingPeriodOptions = [
    "Monthly",
    "Annual"
];
const retentionOptions = [
    "3 months",
    "6 months",
    "1 year",
    "2 years"
];
const retentionMultipliers = {
    "3 months": 1,
    "6 months": 1.5,
    "1 year": 2,
    "2 years": 2.5
};
const tierOptions = [
    "Free",
    "Basic",
    "Essentials",
    "Startup"
];
const priceTiers = {
    Free: {
        basePrice: 0,
        sessions: 500,
        errors: 1000
    },
    Basic: {
        basePrice: 50,
        sessions: 2000,
        errors: 4000
    },
    Essentials: {
        basePrice: 150,
        sessions: 10000,
        errors: 20000
    },
    Startup: {
        basePrice: 400,
        sessions: 80000,
        errors: 160000
    }
};
function getBasePrice(param, billing, retention) {
    let { basePrice  } = param;
    const billingMultiplier = billing === "Annual" ? 0.8 : 1;
    const retentionMultiplier = retentionMultipliers[retention];
    return basePrice * billingMultiplier * retentionMultiplier;
}
const PlanTable = ()=>{
    const [billingPeriod, setBillingPeriod] = (0,react.useState)("Monthly");
    const [retention, setRetention] = (0,react.useState)("3 months");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-center max-w-full gap-6 mx-auto mt-16",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-wrap justify-center gap-12 gap-y-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioOptions, {
                        title: "Billing Period",
                        options: billingPeriodOptions,
                        value: billingPeriod,
                        onChange: setBillingPeriod
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioOptions, {
                        title: "Retention",
                        options: retentionOptions,
                        value: retention,
                        onChange: setRetention
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid items-stretch w-full grid-cols-1 sm:grid-cols-2 min-[1190px]:grid-flow-col gap-7",
                children: Object.entries(priceTiers).map((param)=>/*#__PURE__*/ {
                    let [name, tier] = param;
                    return (0,jsx_runtime.jsx)(PlanTier, {
                        name: name,
                        tier: tier,
                        billingPeriod: billingPeriod,
                        retention: retention
                    }, name);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                type: "copy1",
                onDark: true,
                className: "text-center my-9",
                children: [
                    "If usage goes beyond the included monthly quota, your ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "#overage",
                        children: "usage rate"
                    }),
                    " kicks in."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex-shrink w-48"
            })
        ]
    });
};
const PlanTier = (param)=>{
    let { name , tier , billingPeriod , retention  } = param;
    const { sessions , errors  } = tier;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col flex-grow border rounded-md min-[1190px]:min-w-[255px] basis-64 border-divider-on-dark",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-5 border-b border-divider-on-dark",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        type: "copy1",
                        emphasis: true,
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-end mt-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                type: "copy3",
                                emphasis: true,
                                className: "self-start align-super",
                                children: "$"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "mx-1 text-5xl font-semibold",
                                children: getBasePrice(tier, billingPeriod, retention)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                type: "copy3",
                                children: "/ mo"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-5 flex flex-col gap-2.5 flex-grow",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                type: "copy3",
                                emphasis: true,
                                children: "Included"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "#overage",
                                className: "text-white transition-colors hover:text-blue-cta",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InformationCircleIcon/* default */.Z, {
                                    className: "inline w-5 h-5"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                        type: "copy3",
                        children: [
                            sessions,
                            " monthly sessions"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                        type: "copy3",
                        children: [
                            errors,
                            " monthly errors"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        type: "copy3",
                        children: "Unlimited seats"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "p-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* PrimaryButton */.K, {
                    href: "https://app.highlight.io/sign_up",
                    className: (Home_module_default()).hollowButton,
                    children: "Start free trial"
                })
            })
        ]
    });
};
const formatPrice = (price)=>price.toLocaleString(undefined, {
        style: "currency",
        currency: "USD",
        signDisplay: "always"
    }).replace("+", "+ ");
const PriceCalculator = ()=>{
    const [billingPeriod, setBillingPeriod] = (0,react.useState)("Monthly");
    const [tierName, setTierName] = (0,react.useState)("Free");
    const [retention, setRetention] = (0,react.useState)("3 months");
    const tier = priceTiers[tierName];
    const [errorUsage, setErrorUsage] = (0,react.useState)(0);
    const [sessionUsage, setSessionUsage] = (0,react.useState)(0);
    const [loggingUsage, setLoggingUsage] = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        setErrorUsage(tier.errors);
        setSessionUsage(tier.sessions);
    }, [
        tier,
        tierName
    ]);
    const basePrice = getBasePrice(tier, billingPeriod, retention);
    const getUsagePrice = (usage, price, size)=>Math.trunc(Math.max(usage, 0) * price / size * retentionMultipliers[retention] * 100) / 100;
    const sessionsCost = getUsagePrice(sessionUsage - tier.sessions, 5.0, 1000);
    const errorsCost = getUsagePrice(errorUsage - tier.errors, 0.2, 1000);
    const loggingCost = getUsagePrice(loggingUsage, 1.5, 1000000);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-center w-full gap-10 mx-auto mt-12",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-wrap justify-center gap-12 gap-y-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioOptions, {
                        title: "Billing Period",
                        options: billingPeriodOptions,
                        value: billingPeriod,
                        onChange: setBillingPeriod
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioOptions, {
                        title: "Pricing Tier",
                        options: tierOptions,
                        value: tierName,
                        onChange: setTierName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioOptions, {
                        title: "Retention",
                        options: retentionOptions,
                        value: retention,
                        onChange: setRetention
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-end w-full max-w-[1100px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col overflow-hidden border divide-y rounded-lg md:rounded-br-none divide-divider-on-dark border-divider-on-dark",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "hidden h-12 md:flex",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex items-center flex-1 border-r border-divider-on-dark px-7",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                            type: "copy2",
                                            emphasis: true,
                                            children: "Product"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex items-center justify-center w-[343px] px-7",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                            type: "copy2",
                                            emphasis: true,
                                            children: "Cost breakdown"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CalculatorRowDesktop, {
                                title: "Error Monitoring Usage.",
                                description: "Error monitoring usage is defined by the number of errors collected by Highlight per month. Our frontend/server SDKs send errors, but you can also send custom errors.",
                                value: errorUsage,
                                cost: errorsCost + basePrice,
                                includedRange: tier.errors,
                                onChange: setErrorUsage
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CalculatorRowDesktop, {
                                title: "Session Replay Usage.",
                                description: "Session replay usage is defined by the number of sessions collected per month. A session is defined by an instance of a user’s tab on your application. ",
                                value: sessionUsage,
                                cost: sessionsCost + basePrice,
                                includedRange: tier.sessions,
                                onChange: setSessionUsage
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CalculatorRowDesktop, {
                                title: "Logging Usage.",
                                description: "Log usage is defined by the number of logs collected by highlight.io per month. A log is defined by a text field with attributes.",
                                value: loggingUsage,
                                cost: loggingCost + basePrice,
                                includedRange: 0,
                                rangeMultiplier: 100,
                                onChange: setLoggingUsage
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "block px-3 py-5 rounded-b-lg md:hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                                    type: "copy1",
                                    emphasis: true,
                                    children: [
                                        "Total: ",
                                        formatPrice(basePrice + sessionsCost + errorsCost + loggingCost)
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden border border-t-0 rounded-b-lg md:block h-52 border-divider-on-dark",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CalculatorCostDisplay, {
                            heading: "Total",
                            cost: basePrice + sessionsCost + errorsCost + loggingCost
                        })
                    })
                ]
            })
        ]
    });
};
const CalculatorRowDesktop = (param)=>{
    let { title , description , value , cost , includedRange , rangeMultiplier =1 , onChange  } = param;
    const rangeOptions = [
        0,
        500,
        1000,
        5000,
        10000,
        100000,
        250000,
        500000,
        750000,
        1000000
    ].map((v)=>v * rangeMultiplier);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-row",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col flex-1 gap-1 px-3 py-5 md:px-7",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        type: "copy4",
                        emphasis: true,
                        className: "rounded-full bg-blue-cta py-0.5 px-3 text-dark-background self-start inline-block md:hidden",
                        children: formatPrice(cost)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        type: "copy1",
                        emphasis: true,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        type: "copy3",
                        className: "mt-2.5",
                        children: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RangedInput, {
                        options: rangeOptions,
                        value: value,
                        includedRange: includedRange,
                        onChange: onChange
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden border-l border-divider-on-dark md:inline-block",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CalculatorCostDisplay, {
                    heading: "Base + Usage",
                    cost: cost
                })
            })
        ]
    });
};
const RangedInput = (param)=>{
    let { options , value , includedRange =0 , onChange  } = param;
    const sortedOptions = [
        ...options
    ].sort((a, b)=>a - b);
    var ref;
    const min = (ref = sortedOptions[0]) !== null && ref !== void 0 ? ref : 0;
    var ref1;
    const max = (ref1 = sortedOptions[sortedOptions.length - 1]) !== null && ref1 !== void 0 ? ref1 : 100;
    const snapValue = (value)=>{
        const deltas = sortedOptions.map((v)=>Math.abs(v - value));
        for (const [i, delta] of deltas.entries()){
            var ref;
            if (((ref = deltas[i + 1]) !== null && ref !== void 0 ? ref : Infinity) > delta) return sortedOptions[i];
        }
        return sortedOptions[0];
    };
    const normalize = (value)=>(value - min) / (max - min);
    const denormalize = (normal)=>normal * (max - min) + min;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "block md:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                            className: "flex items-center justify-center w-full h-12 gap-2 text-center text-transparent transition-all border rounded-lg appearance-none cursor-pointer border-copy-on-light hover:bg-white/10 bg-dark-background",
                            onChange: (ev)=>onChange(parseFloat(ev.target.value)),
                            children: options.map((value, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: value,
                                    children: value.toLocaleString(undefined, {
                                        notation: "compact"
                                    })
                                }, i))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "absolute inset-0 flex items-center justify-center w-full h-12 gap-2 transition-all border rounded-lg pointer-events-none border-copy-on-light hover:bg-white/10",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                    type: "copy2",
                                    emphasis: true,
                                    onDark: true,
                                    children: snapValue(value).toLocaleString(undefined, {
                                        notation: "compact"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDownIcon/* default */.Z, {
                                    className: "w-5 h-5 text-darker-copy-on-dark"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_module/* Root */.fC, {
                min: min,
                max: max,
                step: 500,
                value: [
                    denormalize(Math.pow(normalize(value), 1 / 3))
                ],
                onValueChange: (param)=>{
                    let [value] = param;
                    return value != null && onChange(Math.ceil(denormalize(Math.pow(normalize(value), 3))));
                },
                className: "relative items-center hidden w-full h-16 mt-4 select-none md:flex touch-none group",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Track */.fQ, {
                        className: "relative flex-1 h-3 overflow-hidden rounded-full bg-divider-on-dark",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute inset-y-0 left-0 h-full bg-blue-cta/30",
                            style: {
                                width: "".concat(Math.pow(normalize(includedRange), 1 / 3) * 100, "%")
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_module/* Thumb */.bU, {
                        className: "relative w-6 h-6 border-2 focus:border-blue-cta hover:shadow-white/25 hover:shadow-[0_0_0_4px] outline-none bg-[#F5F5F5] border-copy-on-dark rounded-full flex flex-col items-center transition-all",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute w-2.5 h-2.5 rotate-45 rounded-sm -top-4 bg-blue-cta"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute px-1 py-0.5 mb-2 text-divider-on-dark font-semibold text-[10px] rounded-sm bottom-full bg-blue-cta",
                                children: value.toLocaleString(undefined, {
                                    notation: "compact"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const CalculatorCostDisplay = (param)=>/*#__PURE__*/ {
    let { cost , heading  } = param;
    return (0,jsx_runtime.jsxs)("div", {
        className: "grid flex-shrink-0 place-content-center place-items-center w-[343px] h-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                type: "copy3",
                emphasis: true,
                onDark: true,
                children: heading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text-4xl font-semibold",
                children: formatPrice(cost)
            })
        ]
    });
};
const RadioOptions = (param)=>{
    let { title , options , value , onChange  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(radio_group/* RadioGroup */.E, {
        value: value,
        onChange: onChange,
        className: "flex flex-col items-center gap-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_group/* RadioGroup.Label */.E.Label, {
                className: "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                    type: "copy4",
                    className: "text-center text-darker-copy-on-dark",
                    children: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex p-px border rounded-[10px] gap-1 bg-user-black border-divider-on-dark",
                children: options.map((option)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(radio_group/* RadioGroup.Option */.E.Option, {
                        value: option,
                        children: (param)=>/*#__PURE__*/ {
                            let { checked  } = param;
                            return (0,jsx_runtime.jsx)("div", {
                                className: "cursor-pointer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()("text-center px-2.5 py-1.5 select-none rounded-lg transition-colors", checked ? "text-dark-background bg-white" : "text-white hover:bg-white/10"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                        type: "copy3",
                                        emphasis: true,
                                        children: option
                                    })
                                })
                            });
                        }
                    }, option))
            })
        ]
    });
};
/* harmony default export */ var pricing = (PricingPage);


/***/ }),

/***/ 8962:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pricingTable":"Pricing_pricingTable__PGmEh","checkmark":"Pricing_checkmark__ofAZZ","mobileTiers":"Pricing_mobileTiers__hG3Nk","anchorHead":"Pricing_anchorHead___QAmp","tierWrapper":"Pricing_tierWrapper__wAApk","moneySign":"Pricing_moneySign__pnxrP","pricingButton":"Pricing_pricingButton__Oq2yl","timeIndicator":"Pricing_timeIndicator__UUbFS","price":"Pricing_price__ePdl0","desktopPrice":"Pricing_desktopPrice__RSthE","tierHeader":"Pricing_tierHeader__uRuuv","discountPill":"Pricing_discountPill__Lo8UM","discountPillVisible":"Pricing_discountPillVisible__CY_sp","desktopSessionCredits":"Pricing_desktopSessionCredits__IBfYH","desktopSessionCreditsEnterprise":"Pricing_desktopSessionCreditsEnterprise__RboQQ","mostPopular":"Pricing_mostPopular__WZrVx","configColumn":"Pricing_configColumn__QmhJe","featureName":"Pricing_featureName__OsKvD","featureSet":"Pricing_featureSet__E_ecM","featureKey":"Pricing_featureKey__ZWHN_","featureKeys":"Pricing_featureKeys__wrVSt","billingCopy":"Pricing_billingCopy__Hz9XY","billingWidget":"Pricing_billingWidget__PvvTX","billingWidgetButtons":"Pricing_billingWidgetButtons__npfV9","billingButton":"Pricing_billingButton__WKrTi","rightButton":"Pricing_rightButton__dlPan","leftButton":"Pricing_leftButton__piK9w","selected":"Pricing_selected__pLvlG","tierColumn":"Pricing_tierColumn__gakOZ","desktopTopTier":"Pricing_desktopTopTier__s5mtq","mostPopularTierColumn":"Pricing_mostPopularTierColumn__QgDa9","desktopTierSection":"Pricing_desktopTierSection__gmNrj","mobileFeatureDivider":"Pricing_mobileFeatureDivider__dt7T4","featureDivider":"Pricing_featureDivider__HDgep","circleButton":"Pricing_circleButton__XP0yW","expanded":"Pricing_expanded__1ILqR","faqRowClickable":"Pricing_faqRowClickable__yBBcV","faqDivider":"Pricing_faqDivider__EZ9_i","featureKeyDivider":"Pricing_featureKeyDivider__9fz0c","desktopFeaturesSection":"Pricing_desktopFeaturesSection__t_kxB","mobileFeaturesSection":"Pricing_mobileFeaturesSection__JPu3R","sectionSubtitle":"Pricing_sectionSubtitle__SVzdA","yellowText":"Pricing_yellowText__mkwlu","pricingTitle":"Pricing_pricingTitle__cHmUr","mobileNotSelectedPlan":"Pricing_mobileNotSelectedPlan__niGJ_","mobileBillingWrapper":"Pricing_mobileBillingWrapper__Zo_q3","mostPopularTierColumnMobile":"Pricing_mostPopularTierColumnMobile__i_Ipo","mobileFeaturesWrapper":"Pricing_mobileFeaturesWrapper__kV_dl","mobileFeatureRow":"Pricing_mobileFeatureRow__DubyA","mostPopularMobile":"Pricing_mostPopularMobile__cBOGq","mobileFeatureHeader":"Pricing_mobileFeatureHeader__7jUJH","mobileTierCarousel":"Pricing_mobileTierCarousel__hpU6r","mobileFeatureInner":"Pricing_mobileFeatureInner__qw8GL","mobileFeatureName":"Pricing_mobileFeatureName__bpLyU","carousel-div":"Pricing_carousel-div__lkV_g","billingCycleText":"Pricing_billingCycleText__t0VP_","mobileCarousel":"Pricing_mobileCarousel__unoKl","mobileSessionCredits":"Pricing_mobileSessionCredits__HlwFX","mobileTier":"Pricing_mobileTier__0qdHO","mobileTierTop":"Pricing_mobileTierTop__CO3FV","mobilePricingButton":"Pricing_mobilePricingButton__w_Vvb","mobileTierSectionWrapper":"Pricing_mobileTierSectionWrapper__1Lo0U","mobileTierDots":"Pricing_mobileTierDots__ynOox","mobileTierDot":"Pricing_mobileTierDot__2oZpv","dotSelected":"Pricing_dotSelected__g3Vjy","mobileTierWrapper":"Pricing_mobileTierWrapper__cEG8T","customerSection":"Pricing_customerSection__cXX7e","titleSection":"Pricing_titleSection__r8ZSe","question":"Pricing_question__u_oN0","questionDescription":"Pricing_questionDescription__fE1wp","collapseInner":"Pricing_collapseInner__WcO49","faqSection":"Pricing_faqSection__jLmlz","faqRow":"Pricing_faqRow__iyzQl","faqLeftContent":"Pricing_faqLeftContent__od6Hq","anchorFeaturePricing":"Pricing_anchorFeaturePricing__9tAVB","anchorFeature":"Pricing_anchorFeature__aL7tH","buttonContainer":"Pricing_buttonContainer__MypOJ","anchorTitle":"Pricing_anchorTitle__ldDVS","anchorImage":"Pricing_anchorImage__CyZHo","secondaryAnchor":"Pricing_secondaryAnchor__aHoZZ","mobileTierCard":"Pricing_mobileTierCard__xanQy","tableCard":"Pricing_tableCard__eJa04","tierInfo":"Pricing_tierInfo__lkeSJ","tierName":"Pricing_tierName__EZJoy","tierPrice":"Pricing_tierPrice__9HQ0k","priceNum":"Pricing_priceNum__wcPxs","priceDuration":"Pricing_priceDuration__Y1Dk_","startTrial":"Pricing_startTrial__uuCAn","pricingBreakdown":"Pricing_pricingBreakdown__Yrr7u","tableBody":"Pricing_tableBody__V5ppA"};

/***/ }),

/***/ 50246:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__2Pzmc","gridSection":"Section_gridSection__vgdkS","noYTopPadding":"Section_noYTopPadding__CWdmK","noYBottomPadding":"Section_noYBottomPadding__efv2e","sectionReverseMobile":"Section_sectionReverseMobile__q0tjM"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,4617,6556,3826,1399,5675,7916,4117,3890,9774,2888,179], function() { return __webpack_exec__(83542); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);